import styles from "./CataloguePage.module.css";
import classNames from "classnames";
import { useCataloguePage } from "../../Pregrine/CataloguePage/useCataloguePage";
import LoadingIndicator from "../../components/LoadingIndicator";
import { Link, useLocation } from "react-router-dom";

const TABS = [
  { label: "Catalogue", link: "/catalogue" },
  { label: "Video", link: "/media-center" },
];

const CataloguePage = () => {
  const { pathname } = useLocation();
  const route = pathname.replace("/", "");

  const { data, loading, error, selectedCatalogue, handleDownloads } =
    useCataloguePage(route);

  return (
    <section className={styles.catalogue}>
      {loading ? (
        <LoadingIndicator />
      ) : data && data.getCatalogueList && data.getCatalogueList.length > 0 ? (
        <div className="container">
          <div className="row">
            <div className={classNames(styles.title, "pb-2")}>
              <h2 className={styles.title}>Catalogue</h2>
              </div>
          </div>
          <ul
            className={(styles["nav-pills"], "mb-3", "nav")}
            style={{ marginBottom: "16px" }}
          >
            {TABS.map((item, idx) => (
              <>
                <li className="nav-item" role="presentation" key={idx}>
                  {/* <button
                    className={classNames(styles["nav-link"], {
                      [styles.active]: selectedCatalogue === idx,
                    })}
                    id={`Cata${idx}-tab`}
                    data-bs-toggle="tab"
                    data-bs-target={`#Cata${idx}-tab-pane`}
                    type="button"
                    role="tab"
                    aria-controls={`Cata${idx}-tab-pane`}
                    aria-selected={idx === selectedCatalogue}
                    onClick={() => setSelectedCatalogue(idx)}
                  >
                    {item.label}
                  </button> */}
                  <Link
                    className={classNames(styles["nav-link"], {
                      [styles.active]: pathname === item.link,
                    })}
                    to={item.link}
                  >
                    {item.label}
                  </Link>
                </li>
              </>
            ))}
          </ul>
          {/* <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id={`Cata${selectedCatalogue}-tab-pane`}
              role="tabpanel"
              aria-labelledby={`Cata${selectedCatalogue}-tab`}
              tabIndex="0"
            >
            </div>
          </div> */}
          <div className={`row ${styles.row}`}>
            {data &&
            data.getCatalogueList &&
            data.getCatalogueList.length > 0 ? (
              <>
                {data.getCatalogueList.map((item, idx) => (
                  <div className="col-lg-4" key={idx}>
                    <div className="box-card">
                      <div className={styles.content}>
                        {route === "catalogue" ? (
                          <>
                            <div className={styles["content-overlay"]}></div>
                            <img
                              className={styles["content-image"]}
                              src={item.image}
                              alt={item.title}
                            />
                            <div
                              className={classNames(
                                styles["content-details"],
                                "fadeIn-bottom"
                              )}
                            >
                              <h3 className="content-title">{item.title}</h3>
                              <Link
                                to={item.pdf + "#page=1"}
                                target="_blank"
                                className={styles.viewBtn}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                >
                                  <g fill="none">
                                    <path d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
                                    <path
                                      fill="white"
                                      d="M12 4c2.787 0 5.263 1.257 7.026 2.813c.885.781 1.614 1.658 2.128 2.531c.505.857.846 1.786.846 2.656c0 .87-.34 1.799-.846 2.656c-.514.873-1.243 1.75-2.128 2.531C17.263 18.743 14.786 20 12 20c-2.787 0-5.263-1.257-7.026-2.813c-.885-.781-1.614-1.658-2.128-2.531C2.34 13.799 2 12.87 2 12c0-.87.34-1.799.846-2.656c.514-.873 1.243-1.75 2.128-2.531C6.737 5.257 9.214 4 12 4m0 2c-2.184 0-4.208.993-5.702 2.312c-.744.656-1.332 1.373-1.729 2.047C4.163 11.049 4 11.62 4 12c0 .38.163.951.569 1.641c.397.674.985 1.39 1.729 2.047C7.792 17.007 9.816 18 12 18s4.208-.993 5.702-2.312c.744-.657 1.332-1.373 1.729-2.047c.406-.69.569-1.261.569-1.641c0-.38-.163-.951-.569-1.641c-.397-.674-.985-1.39-1.729-2.047C16.208 6.993 14.184 6 12 6m0 3c.088 0 .175.004.261.011a2 2 0 0 0 2.728 2.728A3 3 0 1 1 12 9"
                                    />
                                  </g>
                                </svg>
                                View
                              </Link>
                              <button
                                // onClick={() => {
                                //   const pdfUrl = item.pdf;
                                //   const link = document.createElement("a");
                                //   link.href = pdfUrl;
                                //   link.download = "document.pdf"; // specify the filename
                                //   document.body.appendChild(link);
                                //   link.click();
                                //   document.body.removeChild(link);
                                // }}
                                className={styles.downloadBtn}
                                onClick={() => handleDownloads(item.pdf)}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                >
                                  <g
                                    fill="none"
                                    stroke="white"
                                    stroke-linecap="round"
                                    stroke-width="1.5"
                                  >
                                    <path d="M8 22h8c2.828 0 4.243 0 5.121-.878C22 20.242 22 18.829 22 16v-1c0-2.828 0-4.242-.879-5.121c-.768-.768-1.946-.865-4.121-.877m-10 0c-2.175.012-3.353.109-4.121.877C2 10.758 2 12.172 2 15v1c0 2.829 0 4.243.879 5.122c.3.3.662.497 1.121.627" />
                                    <path
                                      stroke-linejoin="round"
                                      d="M12 2v13m0 0l-3-3.5m3 3.5l3-3.5"
                                    />
                                  </g>
                                </svg>{" "}
                                <span className="pe-2 mt-1">Download</span>
                              </button>
                            </div>
                          </>
                        ) : (
                          <div
                            dangerouslySetInnerHTML={{ __html: item.video_url }}
                            className={classNames(styles.iframeWrapper, {
                              [styles.lastIframe]:
                                idx === data.getCatalogueList.length - 1,
                            })}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                ))}
                {route === "catalogue" && data.getCatalogueList.length > 0 && (
                  <Link
                    to="https://app.box.com/folder/201049478852?s=pt1etr34k6dpdo4aclimejq1ts363nb1"
                    target="_blank"
                    referrerPolicy="no-referrer"
                  >
                    View All
                  </Link>
                )}
              </>
            ) : (
              <p>No Content To Show</p>
            )}
          </div>
        </div>
      ) : (
        <p>No Content To Show</p>
      )}
    </section>
  );
};

export default CataloguePage;
